import React from 'react';
import AttachmentContext from './attachment-context';
import { createAttachment, createS3DirectUploadImage, updateAttachment } from './attachment-api';

export default function AttachmentProvider({children}) {
  const state = {
    createAttachment,
    createS3DirectUploadImage,
    updateAttachment
  };

  return (
    <AttachmentContext.Provider value={state}>
      {children}
    </AttachmentContext.Provider>
  )
};
